export class UserConnection {
    public userUuid1: string;
    public userUuid1Status: string;
    public userUuid1Date: Date;
    public userUuid2: string;
    public userUuid2Status: string;
    public userUuid2Date: Date;
}
